<script>
import JsonViewer from 'vue-json-viewer';
import { componentStore } from "@common/componentStore/componentStore";

const editorSettings = {
    typeOfTest: {
        label: 'Type of Test',
        type: 'dropdown',
        id: 'typeOfTest',
        items: [
            { text: 'Fields Request', value: 'fields' },
            { text: 'Dataset Request', value: 'dataset' },
            { text: 'sDs Request', value: 'sds' },
            { text: 'Show Stats', value: 'stats' },
        ],
        fields: {
            text: 'text', value: 'value'
        },
        default: []
    },
    testDatasets: {
        type: 'datasource',
        mode: 'Box',
        itemsSource: 'configStore.getDatasourceList()',
        fields: {
            text: 'text',
            value: 'value',
            parentValue: 'pId',
            hasChildren: 'hasChild'
        },
        allowFiltering: true,
        default: [],
        label: "Select a datasource",
        filterType: 'contains',
        // onchange: "selectDataset",
        helpText: 'Dataset that provides data for this component',
        id: 'testDatasets',
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.typeOfTest && (this.valuesMap.typeOfTest === "dataset" || this.valuesMap.typeOfTest === "sds")'
            }
        ],
    },
    recordType: {
        label: 'Type of Record',
        type: 'dropdown',
        id: 'recordType',
        items: [
            { value: 'vol', text: 'Volunteer' },
            { value: 'opp', text: 'Opportunity' },
            { value: 'org', text: 'Organization' }
        ],
        fields: {
            text: 'text',
            value: 'value'
        },
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.typeOfTest && this.valuesMap.typeOfTest !== "stats"'
            }
        ],
    },
    providedId: {
        label: 'Provided Record ID',
        type: 'string',
        id: 'providedId',
        default: '',
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.typeOfTest && this.valuesMap.typeOfTest !== "stats"'
            }
        ],
    },
    userFields: {
        label: 'Fields to Request',
        type: 'multiselect',
        id: 'userFields',
        itemsSource: 'configStore.allFieldOptions()',
        fields: {
            text: 'text', value: 'value', parentValue: 'pId', hasChildren: 'hasChild'
        },
        logic: [
            {
                record: 'self.object1',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.valuesMap.typeOfTest && this.valuesMap.typeOfTest === "fields"'
            }
        ],
        default: []
    }
};

let recordStoreTestConfig = {
    cId: "recordStoreTest",
    cType: "recordStoreTest",
    cTitle: "recordStore Test",
    cTemplate: `<div class="record-store-test">
                    <div class="record-store-header-container">
                        <div>
                            <h2>{{this.config.cTitle}}</h2>
                        </div>
                        <div>
                            <div class="id-item-line" v-if="config.typeOfTest === 'stats'"><strong>Time since last request: <span class="id-item">{{requestTimer}}</span></strong></div>
                            <div class="id-item-line" v-if="config.providedId"><strong>Record ID: <span class="id-item">{{config.providedId}}</span></strong></div>
                            <div class="id-item-line" v-if="currentSourceId"><strong>Subscription ID: <span class="id-item">{{currentSourceId}}</span></strong></div>
                        </div>
                    </div>
                    <div v-if="config.typeOfTest === 'stats'">
                        <h3>Stats</h3>
                        <div class="request-type-stats">
                            <div v-for="type in requestTypes" :key="type">
                                <h4>{{library.titleCase(type)}} Totals</h4>
                                <table>
                                    <tr><td colspan="2"><strong>Requests</strong></td></tr>
                                    <tr>
                                        <td>Total</td>
                                        <td class="stat-item-td"><span class="stat-item">{{totalCounts[type].requests_total}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Initial</td>
                                        <td class="stat-item-td"><span class="stat-item">{{totalCounts[type].requestsInitial_total}} / {{totalCounts[type].requestsInitial_average}}%</span></td>
                                    </tr>
                                    <tr>
                                        <td>Update</td>
                                        <td class="stat-item-td"><span class="stat-item">{{totalCounts[type].requestsUpdate_total}} / {{totalCounts[type].requestsUpdate_average}}%</span></td>
                                    </tr>
                                    <tr><td colspan="2"><strong>Bytes Transferred (in kilobytes)</strong></td></tr>
                                    <tr>
                                        <td>Initial</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Data transferred for requests (in kilobytes)">{{totalCounts[type].bytesInitial_total}}kb / {{totalCounts[type].bytesInitial_average}}kb</span></td>
                                    </tr>
                                    <tr>
                                        <td>Update</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Data transferred for requests (in kilobytes)">{{totalCounts[type].bytesUpdate_total}}kb / {{totalCounts[type].bytesUpdate_average}}kb</span></td>
                                    </tr>
                                    <tr>
                                        <td>All</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Data transferred for requests (in kilobytes)">{{totalCounts[type].bytes_total}}kb / {{totalCounts[type].bytes_average}}kb</span></td>
                                    </tr>
                                    <tr><td colspan="2"><strong>Duration (seconds)</strong></td></tr>
                                    <tr>
                                        <td>Initial</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Time spent on requests (in seconds)">{{totalCounts[type].durationsInitial_total}}s / {{totalCounts[type].durationsInitial_average}}s</span></td>
                                    </tr>
                                    <tr>
                                        <td>Update</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Time spent on requests (in seconds)">{{totalCounts[type].durationsUpdate_total}}s / {{totalCounts[type].durationsUpdate_average}}s</span></td>
                                    </tr>
                                    <tr>
                                        <td>All</td>
                                        <td class="stat-item-td"><span class="stat-item" title="Time spent on requests (in seconds)">{{totalCounts[type].durations_total}}s / {{totalCounts[type].durations_average}}s</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="field-item-list" v-if="recordsWatching || (listOfFields && listOfFields.length)">
                            <div v-if="recordsWatching">
                                <span class="h4">Records in {{currentSourceId}}: </span>
                                <span class="field-item">{{recordsWatching}}</span>
                            </div>
                            <div v-if="listOfFields && listOfFields.length">
                                <span class="h4">Fields in {{config.providedId}}: </span>
                                <span v-for="field in listOfFields" class="field-item">{{field}}</span>
                            </div>
                        </div>
                        <div style="padding: 10px; display: flex; border-top: 1px solid #ccc;">
                            <control name="RECORD_TO_DISPLAY" style="margin-right: 10px;" :value="recordToDisplay" @update:value="recordToDisplay = $event;"></control>
                            <control name="OTHER_RECORD_PSP" v-if="recordToDisplay === 'otherRecord'" style="width: 140px; display: inline-block; margin-right: 10px;" :value="otherRecordPsp" @update:value="otherRecordPsp = $event;"></control>
                            <control name="OTHER_RECORD_ID" v-if="recordToDisplay === 'otherRecord'" style="width: 80px display: inline-block;" :value="otherRecordId" @update:value="otherRecordId = $event;"></control>
                        </div>
                        <div style="padding: 10px;">
                            <control name="CHANGE_RECORD"></control>
                        </div>
                        <div v-show="recordToDisplay !== 'none'">
                            <div class="request-data-pane">
                                <div class="request-pane-inner">
                                    <json-viewer
                                        :value="displayRecord"
                                        :expand-depth=1
                                        copyable
                                        boxed
                                        sort></json-viewer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'CHANGE_RECORD',
            type: 'button',
            label: 'Test Change',
            onclick: 'testChangeCurrentRecord'
        },
        {
            name: 'RECORD_TO_DISPLAY',
            type: 'dropdown',
            label: 'Show Details For',
            items: [
                { text: 'None', value: 'none' },
                { text: 'Current Subscription', value: 'currentRecord' },
                { text: 'Affiliated Records', value: 'affiliatedRecords' },
                { text: 'Other Record', value: 'otherRecord' },
            ],
            fields: {
                text: 'text',
                value: 'value'
            }
        },
        {
            name: 'OTHER_RECORD_PSP',
            type: 'dropdown',
            label: 'Perspective',
            items: [
                'vol',
                'opp',
                'org',
                'sch',
                'lbe',
            ]
        },
        {
            name: 'OTHER_RECORD_ID',
            type: 'string',
            label: 'Record ID'
        }
    ]
};

let recordStoreTestCmp = {
    name: 'recordStoreTest',
    editorSettings: editorSettings,
    data() {
        return {
            recordToDisplay: 'currentRecord',
            otherRecordId: false,
            otherRecordPsp: '',
            groupedRequests: {
                fields: {},
                dataset: {},
                sds: {}
            },
            receivedRequestCount: 0,
            historical: {
                fields: {
                    requests: [0],
                    requestsInitial: [0],
                    requestsUpdate: [0],
                    bytes: [0],
                    bytesInitial: [0],
                    bytesUpdate: [0],
                    durations: [0],
                    durationsInitial: [0],
                    durationsUpdate: [0],
                },
                dataset: {
                    requests: [0],
                    requestsInitial: [0],
                    requestsUpdate: [0],
                    bytes: [0],
                    bytesInitial: [0],
                    bytesUpdate: [0],
                    durations: [0],
                    durationsInitial: [0],
                    durationsUpdate: [0]
                },
                sds: {
                    requests: [0],
                    requestsInitial: [0],
                    requestsUpdate: [0],
                    bytes: [0],
                    bytesInitial: [0],
                    bytesUpdate: [0],
                    durations: [0],
                    durationsInitial: [0],
                    durationsUpdate: [0]
                }
            },
            timerInterval: false,
        };
    },
    computed: {
        totalCounts() {
            let output = {};
            let setSums = (type) => {
                let keys = ['requests', 'requestsInitial', 'requestsUpdate', 'bytes', 'bytesInitial', 'bytesUpdate', 'durations', 'durationsInitial', 'durationsUpdate'];
                keys.forEach((key) => {
                    if (this.historical && this.historical[type]) {
                        output[type][key + '_total'] = this.sumTotal(this.historical[type][key]);
                        // Set averages
                        if (key.indexOf('requests') === -1) {
                            let avgKey = key.replace(/durations|bytes/, 'requests');
                            let divider = this.sumTotal(this.historical[type][avgKey]);
                            output[type][key + '_average'] = divider
                                ? Number((output[type][key + '_total'] / divider).toFixed(2)) // NOSONAR
                                : 0;
                        } else if (key !== 'requests') {
                            let avgKey = 'requests';
                            let divider = output[type][key + '_total'];
                            output[type][key + '_average'] = divider
                                ? Number(((divider / this.sumTotal(this.historical[type][avgKey])) * 100).toFixed(2)) // NOSONAR
                                : 0;
                        }
                    }
                });
            };
            let requestTypes = ['fields', 'dataset', 'sds'];
            requestTypes.forEach((type) => {
                output[type] = {};
                setSums(type);
            });
            return output;
        },
        requestTimer() {
            return this.recordStore.timeSinceLastRefresh;
        },
        currentRecord() {
            if (this.currentSources && this.recordToDisplay === 'currentRecord') return this.currentSources;
            let recordId = this.config.providedId;
            if (!recordId) return false;
            let source = this.config.recordType && 'er_' + library.capitalizeFirstLetter(this.config.recordType) + 'Fields';
            let fields = Array.isArray(this.config.userFields)
                && this.config.userFields.map((field) => field.split(':::')[1]);
            // UI will be reactive
            let subscription = this.recordStore.subscribe({ source, params: { recordId, fields } }, this.cId);
            // Return full record
            return this.recordStore.records.subscription[subscription.key]; // Reactive
            // optionally return only partial records
            // let currentRecord = {};
            // fields.forEach((field) => { currentRecord[field] = this.recordStore.records.vol[recordId][field]; });
            // return currentRecord;
        },
        affiliatedRecords() {
            let orgs = [];
            if (this.currentRecord.affiliations) {
                let keys = Object.keys(this.currentRecord.affiliations);
                keys.forEach((key) => {
                    let orgId = this.currentRecord.affiliations[key].ORGANIZATION_ID;
                    orgs.push(this.recordStore.records.org[orgId]);
                });
            }
            return orgs;
        },
        otherRecord() {
            let id = this.otherRecordId;
            let type = this.otherRecordPsp;
            return id && type && this.recordStore.records[type][id];
        },
        displayRecord() {
            return this.recordToDisplay !== 'none' && this[this.recordToDisplay];
        },
        currentSourceConfig() {
            // currently use only first datasource
            if (this.config.typeOfTest !== 'dataset' && this.config.typeOfTest !== 'sds') return false;
            let dsConfig = Array.isArray(this.config.testDatasets) && this.config.testDatasets[0];
            return typeof dsConfig === 'object'
                && dsConfig !== null
                && dsConfig;
        },
        currentSourceId() {
            return this.currentSourceConfig && this.currentSourceConfig.source[0];
        },
        currentSources() {
            let output = {};
            if (!this.currentSourceConfig) return false;
            let srcConfig = this.currentSourceConfig;
            let recordsObj = {
                rowID: this.config.providedId
            };
            // Map params to records and other contextual or static information
            let params = library.recordSourceMapper(srcConfig.source[0], srcConfig.params, recordsObj, this);
            let payload = {
                source: srcConfig.source[0],
                params
            };
            let subscription = this.recordStore.subscribe(payload, this.cId);
            output[subscription.key] = this.recordStore.records.subscription[subscription.key]; // reactive
            return output;
        },
        recordsWatching() {
            return Object.keys(this.currentSources).length;
        },
        listOfFields() {
            return (this.config && this.config.userFields && this.config.userFields.map((field) => field.split(':::')[1])) || false;
        },
        requestTypes() {
            if (this.config.typeOfTest === 'stats') return ['fields', 'dataset', 'sds'];
            return [this.config.typeOfTest];
        }
    },
    methods: {
        testChangeCurrentRecord() {
            let rId = this.config.providedId; // 106819
            let rType = this.config.recordType;
            if (!rId) return;
            if (rType === 'vol') this.recordStore.records.vol[rId].VOL_FIRST_NAME = 'Test';
            else if (rType === 'opp') this.recordStore.records.vol[rId].OPP_TITLE = 'Test';
            else if (rType === 'org') this.recordStore.records.vol[rId].ORG_TITLE = 'Test';
            setTimeout(() => {
                if (rType === 'vol') this.recordStore.records.vol[rId].VOL_FIRST_NAME = 'Updated';
                else if (rType === 'opp') this.recordStore.records.vol[rId].OPP_TITLE = 'Updated';
                else if (rType === 'org') this.recordStore.records.vol[rId].ORG_TITLE = 'Updated';
            }, 5000); // NOSONAR
        },
        sumTotal(dataArray) {
            let total = 0;
            if (typeof dataArray === 'number') total = dataArray;
            else total = dataArray.reduce((accumulator, currentValue) => accumulator + currentValue);
            return Number(total.toFixed(2)); // NOSONAR
        },
        onCreate() {
            // Reset resource request timings so we can count how many requests are sent when data from recordStore is called
            if (!window.recordStoreTestFirstLoad) {
                window.recordStoreTestFirstLoad = true;
                performance.clearResourceTimings();
            }
        },
        onLoad() {
            if (this.config.typeOfTest === 'stats') this.checkRequestCount();
        },
        checkRequestCount() {
            this.timerInterval = setInterval(() => {
                let requests = performance.getEntries().filter((request) => request.name.indexOf('&subscription') > -1);
                // Check if we have new subscription requests
                if (requests.length <= this.receivedRequestCount) return;
                let firstNewIndex = this.receivedRequestCount;
                requests = requests.splice(firstNewIndex);
                // Combine Subscription and request details and put into this.groupedRequests
                requests.forEach((request) => {
                    let subscriptionKey = new URLSearchParams(request.name).get('subscription');
                    let subDetails = this.recordStore.subscriptions[subscriptionKey];
                    if (!subDetails) return; // It's an old request or component was reloaded
                    request.subscription = subDetails;
                    request.subscriptionKey = subscriptionKey;
                    let sourceType = subDetails.sourceType;
                    let gRequests = this.groupedRequests;
                    if (!gRequests[sourceType][subscriptionKey]) gRequests[sourceType][subscriptionKey] = [];
                    gRequests[sourceType][subscriptionKey].push(request);
                    this.receivedRequestCount++;
                });
                // Group by subKey and update counts
                this.updateRequestCounts();
            }, 1000); // NOSONAR
        },
        updateRequestCounts() {
            let convertVal = (val) => {
                val = Number(val);
                return Number((val / 1000).toFixed(2)); // NOSONAR
            };
            let reqTypes = Object.keys(this.groupedRequests);
            reqTypes.forEach((reqType) => {
                let requestsOfType = Object.keys(this.groupedRequests[reqType]);
                let total = 0;
                let update = 0;
                let totalBytes = 0;
                let updateBytes = 0;
                let initialBytes = 0;
                let totalDuration = 0;
                let updateDuration = 0;
                let initialDuration = 0;
                this.historical[reqType].requestsInitial = requestsOfType.length;
                requestsOfType.forEach((subOfType) => {
                    let requestsToSum = this.groupedRequests[reqType][subOfType];
                    total += requestsToSum.length;
                    update += (requestsToSum.length - 1);
                    requestsToSum.forEach((iRequest, index) => {
                        if (index === 0) {
                            initialBytes += iRequest.transferSize;
                            initialDuration += iRequest.duration;
                        } else {
                            updateBytes += iRequest.transferSize;
                            updateDuration += iRequest.duration;
                        }
                        totalBytes += iRequest.transferSize;
                        totalDuration += iRequest.duration;
                    });
                });
                this.historical[reqType].requests = total;
                this.historical[reqType].requestsUpdate = update;
                this.historical[reqType].bytes = convertVal(totalBytes);
                this.historical[reqType].bytesInitial = convertVal(initialBytes);
                this.historical[reqType].bytesUpdate = convertVal(updateBytes);
                this.historical[reqType].durations = convertVal(totalDuration);
                this.historical[reqType].durationsInitial = convertVal(initialDuration);
                this.historical[reqType].durationsUpdate = convertVal(updateDuration);
            });
        }
    },
    beforeUnmount() {
        clearInterval(this.timerInterval);
    },
    components: {
        'json-viewer': JsonViewer
    }
};

componentStore.initComponent(recordStoreTestCmp, recordStoreTestConfig);
export { recordStoreTestCmp, recordStoreTestConfig };
export default recordStoreTestCmp;
</script>

<style scoped>
    .record-store-test {
        padding: 10px;
        border: 2px solid #ce8a8a;
    }
    .record-store-header-container {
        display: flex;
        flex-direction: row;
    }
    .record-store-header-container > div + div {
        text-align: right;
        flex-grow: 1;
    }
    .request-data-pane .request-pane-inner {
        max-height: 400px;
        overflow: auto;
    }
    .request-type-stats {
        display: flex;
        margin: 10px 0;
        flex-direction: row;
    }
    .request-type-stats > div {
        margin-right: 10px;
        padding: 5px;
    }
    .request-type-stats > div > table td {
        padding: 2px;
    }
    .stat-item, .field-item, .id-item {
        display: inline-block;
        padding: 3px 5px;
        background: #efd3b0;
        border-radius: 4px;
        font-weight: bold;
    }
    .stat-item-td {
        text-align: right;
    }
    .field-item {
        background: #b0d6ef;
        margin-right: 5px;
        margin-bottom: 2px;
    }
    .field-item-list > div {
        margin-bottom: 5px;
    }
    .id-item {
        background: #c6efb0;
    }
    .id-item-line {
        margin-bottom: 2px;
    }
    h2, h3, h4 {
        margin-bottom: 10px;
    }
    h3 {
        font-size: 18px;
        font-weight: bold;
    }
    h4, .h4 {
        font-size: 14px;
        font-weight: bold;
        color: #666;
    }
</style>
